<template>
  <v-layout align-center column class="empty-state">
    <component data-qa="empty-state__svg" class="empty-state__svg" :is="getIcon"/>

    <div class="empty-state__title">
      {{ title }}
    </div>
    <div class="empty-state__subtitle" v-html="subtitle" />
    <VcButton v-if="buttonText"
              :label="buttonText"
              small
              @click="$emit('cta-click')"/>
    <div v-if="liveTextButton"
         class="empty-state__live-text-button"
         @click="$emit('live-text-button-click')">
      {{liveTextButton}}
    </div>
    <slot name="footer" />
  </v-layout>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    svgPath: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: false
    },
    liveTextButton: {
      type: String,
      default: '',
    },
  },
  computed: {
    getIcon() {
      return require('@/assets/images/' + this.svgPath);
    }
  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.empty-state {
  padding: 0 30px;
  text-align: center;

  &__svg {
    margin-bottom: 20px;
  }

  &__title {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  &__subtitle {
    font-size: 13px;
    color: $grey-color-6;
  }

  &__live-text-button {
    width: 100%;
    text-align: center;
    color: #6793f7;
    margin-top: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 13px;
  }

  .v-btn {
    font-size: 13px;
    font-weight: bold;
    margin: 15px 0;
    border-radius: 47px;
    padding: 15px;
  }


}
</style>
